<template>
    <div id="wrap" o-Container o-Container-App>
        <template v-if="isShowPage">
            <div class="img"></div>
            <p class="update1">我们平台升级啦！</p>
            <p class="update2">请跳转到国动智充+小程序中充电。</p>
            <p class="update3">已充值的电卡请重新绑定，请到小程序<br/>“我的”-“电卡管理”中绑定。</p>
            <wx-open-launch-weapp
                :id="info.eleId"
                :username="info.olderID"
                :path="info.url"
                v-if="payMethods !== 'aliPay'"
                class="btn">
                <script type="text/wxtag-template">
                    <style>.btn { font-size: 14px;background-image: linear-gradient(#FF002B, #FF6565);width: 223px;height: 46px;border-radius: 23px;border: none;color: #fff;} .btn:focus { outline:none; }</style>
                    <button class="btn">马上使用</button>
                </script>
            </wx-open-launch-weapp>
            <input class="btn" @click="toAliPayApplet" v-if="payMethods == 'aliPay'" type="button" value="马上使用" />
        </template>
    </div>
</template>

<script>
import axios from 'axios';
import wx from '@/assets/tools/WxSdk';
  export default {
      name: "system", //名称
      data() {
          return {
              octopus: this.$parent.octopus,
              payMethods: '',
              isShowPage: false,
              info: {},
              supplier: ''
          }
      },
      created() {
          document.title = '国动智充+'; //设置title
          this.supplier = this.$route.query.supplier;
          this.selectWxOrAli();
      },
      methods: {
          selectWxOrAli() {
              if (/MicroMessenger/.test(window.navigator.userAgent)) {
                  this.payMethods = 'wxchat';
              } else if (/AlipayClient/.test(window.navigator.userAgent)) {
                  this.payMethods = 'aliPay';
              }
              this.isToAppletOrH5();
          },
          isToAppletOrH5() {
              axios.get('https://api.smart.guodongiot.com:444/charging_pile/applet/querydeviceexists?deviceCode='+this.$route.query.deviceID)
              .then(res => {
                  this.isShowPage = true;
                  res = res.data;
                  if (res && res.content && res.content.exists) {
                      if (this.payMethods == 'aliPay') {
                          this.toAliPayApplet();
                      } else {
                          this.toWxApplet();
                      }
                  } else {
                      window.location.replace('http://wechat3.sdaascloud.com/html/chosesocket.html?qr='+this.$route.query.deviceID); //跳转
                  }
              })
          },
          toAliPayApplet() {
              if(this.supplier == 'qingning'){
                  window.location.replace("alipays://platformapi/startapp?appId=2021002122614857&page=xxxx/xxx/xxx");
              }else {
                // window.location.replace("alipays://platformapi/startapp?appId=2021001179642736&page=pages/webView/index"+encodeURIComponent("?webViewUrl=/Applet/Chargingpile/ChargingDetails/Page&isScan=1&deviceID="+this.$route.query.deviceID));
                  // 2.0
                  window.location.replace("alipays://platformapi/startapp?appId=2021002189655858&page=pages/index/index"+encodeURIComponent("?deviceID="+this.$route.query.deviceID) )
                //   window.location.replace("alipays://platformapi/startapp?appId=2021002189655858&page=pages/index/index");
              }
          },
          toWxApplet () {
              if(this.supplier == 'qingning'){
                  this.info = {
                      eleId:"launch-btn", // 元素id
                      url: "", // 跳转小程序的页面路径
                      olderID: 'gh_',//参数
                  };
              }else {
                //   this.info = {
                //       eleId:"launch-btn", // 元素id
                //       url: "/pages/webView/index.html?q=https://guodongiot.com?deviceID="+this.$route.query.deviceID, // 跳转小程序的页面路径
                //       olderID: 'gh_83a81aed7381',//参数
                //   };
                  // 2.0
                  this.info = {
                    eleId:"launch-btn", // 元素id
                    url: "/pages/index/index.html?q=https://guodongiot.com?deviceID="+this.$route.query.deviceID, // 跳转小程序的页面路径
                    olderID: 'gh_d0f216ab9e41',//参数
                };
              }
              axios.get('https://api.smart.guodongiot.com:444/charging_pile/applet/wechat/getsignal?url=' + encodeURIComponent(location.href.split("#")[0]))
                .then(res => {//参数
                    res = res.data;
                    wx.config({
                        debug: false,//参数
                        appId: res.content.appID, //参数
                        timestamp: res.content.timestamp,//参数
                        nonceStr: res.content.nonceStr,//参数
                        signature: res.content.signature,//参数
                        //需要微信权限列表
                        jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage'],//参数
                        openTagList:['wx-open-launch-weapp'] // 微信开放标签 小程序跳转按钮：<wx-open-launch-weapp>
                    });
                    wx.ready(_ => {
                    })
                })
          }
      }
  }
</script>



// WEBPACK FOOTER //
// src/components/Applet/Chargingpile/Page.vue